import { API_URL, MOCK_ENABLED } from "../../constants";
import * as httpNetworking from "../../httpNetworking";
import { SassAppDevData } from "../../dashboard/saas/types";

const VERSION = 0;
const GET_DEPLOYMENT_STATUS_API_VERSION = 3;

export async function getDeploymentStatus(appId: string, deploymentId: string): Promise<SassAppDevData> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000
    };

    const result = await httpNetworking.simpleGETRequest(
        `${API_URL}/saas/${appId}/deployment/status/?deploymentId=${deploymentId}`,
        options,
        GET_DEPLOYMENT_STATUS_API_VERSION
    );
    return result.data;
}

export async function updateDeployment(appId: string, deploymentId: string, newValues: any) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000
    };

    const result = await httpNetworking.simplePUTRequest(
        `${API_URL}/saas/${appId}/deployment`,
        { action: "config-change", deploymentId: deploymentId, newValues },
        options,
        VERSION
    );

    return result.data;
}
